import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
  Link
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import ApiIcon from '@mui/icons-material/Api';
import EmailIcon from '@mui/icons-material/Email';
import CloudSyncIcon from '@mui/icons-material/CloudSync';
import { styled } from '@mui/material/styles';

const HeaderCard = styled(Card)(({ theme }) => ({
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  color: 'white',
  marginBottom: theme.spacing(3),
  borderRadius: '16px',
  boxShadow: '0 8px 32px rgba(102, 126, 234, 0.3)',
}));

const ThirdPartyIntegrations = () => {
  const integrations = [
    {
      title: 'HISP & Direct Messaging',
      description: 'Configure HISP connections and send secure Direct protocol messages and clinical documents.',
      icon: <CloudSyncIcon sx={{ fontSize: 40 }} />,
      link: '/admin/hisp-connection',
      color: '#0079b8'
    },
    {
      title: 'API Integrations',
      description: 'Set up and manage API connections with external healthcare systems and services.',
      icon: <ApiIcon sx={{ fontSize: 40 }} />,
      link: '/admin/api-integrations',
      color: '#228b22'
    },
    {
      title: 'Lab Integration',
      description: 'Manage electronic lab integrations and routing for internal and external providers.',
      icon: <CloudSyncIcon sx={{ fontSize: 40 }} />,
      link: '/procedures/lab-integration',
      color: '#0079b8'
    },
    {
      title: 'Email Services',
      description: 'Configure email service providers for secure patient communication.',
      icon: <EmailIcon sx={{ fontSize: 40 }} />,
      link: '/admin/email-services',
      color: '#dc3545'
    }
  ];

  return (
    <Box sx={{ p: 3 }}>
      <HeaderCard>
        <CardContent sx={{ py: 1.5, px: 3, '&:last-child': { pb: 1.5 } }}>
          <Typography variant="h4" sx={{ fontWeight: 700 }}>
            Integrations
          </Typography>
        </CardContent>
      </HeaderCard>
      <Typography variant="body1" color="text.secondary" paragraph>
        Configure and manage integrations with external services and systems.
      </Typography>

      <Grid container spacing={3}>
        {integrations.map((integration) => (
          <Grid item xs={12} sm={6} md={4} key={integration.title}>
            <Card 
              sx={{ 
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                transition: 'transform 0.2s',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: 3
                }
              }}
            >
              <CardContent sx={{ flexGrow: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <Box sx={{ color: integration.color, mr: 2 }}>
                    {integration.icon}
                  </Box>
                  <Typography variant="h6" component="div">
                    {integration.title}
                  </Typography>
                </Box>
                <Typography variant="body2" color="text.secondary">
                  {integration.description}
                </Typography>
              </CardContent>
              <CardActions>
                <Button
                  component={RouterLink}
                  to={integration.link}
                  variant="contained"
                  sx={{ 
                    backgroundColor: integration.color,
                    '&:hover': {
                      backgroundColor: integration.color,
                      opacity: 0.9
                    }
                  }}
                >
                  Configure
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ThirdPartyIntegrations; 